import { LocationNumbersService } from '../../../services'

const fetchNumberPools = async function ({ commit, state, getters, dispatch }, config) {

    const { numberPools } = config

  if (!numberPools?.length) {
    return []
  }

  commit('startLoading')
  try {
    const data = await LocationNumbersService.getNumberPools(numberPools)

    const mappedNumberPools = data.map((datum) => ({
      ...datum.data,
      id: datum.id,
    }))
    
    commit('setNumberPoolIDs', numberPools)
    commit('setNumberPools', mappedNumberPools)
    commit('setNumberPoolsLookupTable', 'id')
    commit('stopLoading')

    return mappedNumberPools
  } catch (error) {
    commit('stopLoading')
    throw error
  }
}

export default fetchNumberPools
